export enum Role {
  Admin = 1,
  User = 2,
  ReadOnly = 3,
  DataAnalyst = 4,
  InterfaceUser = 5,
}
